import { render } from "./GivingSummary.vue?vue&type=template&id=19346629"
import script from "./GivingSummary.vue?vue&type=script&lang=js"
export * from "./GivingSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__